import { configure } from 'mobx';
import { enableLogging } from 'mobx-logger';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import 'telia-front-react/public/css/diil.css';
import 'telia-front-react/public/css/global.css';
import App from './App';
import config from './config';

configure({
  useProxies: 'never',
  enforceActions: 'observed'
});

if (DEVELOPMENT) {
  enableLogging({
    action: true,
    reaction: true,
    transaction: true,
    compute: true
  });
}

const render = (AppComponent: React.ComponentClass) => {
  ReactDOM.render(<AppComponent />, document.getElementById('container'));
};

config.initialize(window.INITIAL_CONFIG);
render(App);
